import { LANDING_URL } from "../config";

export const subscriptionsInfo = {
  homebuyer: {
    learnMoreLink: `${LANDING_URL}/about/christee-for-home-buyers/`,
    content: [
      {
        type: "homebuyer_premium",
        title: "Homebuyer",
        premium: true,
        link: "/signup/homebuyer-premium",
      },
    ],
  },
  agent: {
    learnMoreLink: `${LANDING_URL}/about/christee-for-real-estate-agents/`,
    content: [
      {
        type: "agent_basic_10",
        title: "Agent",
        premium: false,
        link: "/signup/agent-basic",
        trial: {
          period: "after 30-day trial",
        },
        hidden: true,
      },
      {
        type: "agent_basic",
        title: "Agent",
        premium: false,
        link: "/signup/agent-basic",
        discount: {
          period: "first year",
        },
        trial: {
          period: "after 30-day trial",
        },
        hidden: true,
      },
      {
        type: "agent_basic_free",
        title: "Agent",
        premium: false,
        link: "/signup/agent-basic",
      },
      {
        type: "agent_zip_code",
        title: "Agent",
        premium: true,
        link: "/signup/agent-premium",
        renewLink: "/subscription/renew/agent-premium",
        hidden: true,
      },
    ],
  },
  "loan officer": {
    learnMoreLink: `${LANDING_URL}/about/for-loan-officers/`,
    content: [
      {
        type: "loan_officer_basic_10",
        title: "Loan Officer",
        premium: false,
        link: "/signup/loan-officer-basic",
        trial: {
          period: "after 30-day trial",
        },
        hidden: true,
      },
      {
        type: "loan_officer_basic",
        title: "Loan Officer",
        premium: false,
        link: "/signup/loan-officer-basic",
        discount: {
          period: "first year",
        },
        trial: {
          period: "after 30-day trial",
        },
        hidden: true,
      },
      {
        type: "loan_officer_basic_free",
        title: "Loan Officer",
        premium: false,
        link: "/signup/loan-officer-basic",
      },
      {
        type: "loan_officer_state",
        title: "Loan Officer",
        premium: true,
        link: "/signup/loan-officer-premium",
        renewLink: "/subscription/renew/loan-officer-premium",
        hidden: true,
      },
    ],
  },
};
